import PropTypes from 'prop-types'
import React, { Component } from 'react'
import cx from 'classnames'
import { PreviewState } from '../../constants'

import style from './style.styl'

const PreviewButtons = ({ previewState, onPreviewStateChanged }) => (
  <div className={style.PreviewButtons}>
    <span>Preview:</span>
    <div className="buttons">
      <button
        onClick={onPreviewStateChanged(PreviewState.ONLINE)}
        className={
          cx({ selected: previewState === PreviewState.ONLINE })
        }>
        Online
      </button>
      <button
        onClick={onPreviewStateChanged(PreviewState.AWAY)}
        className={
          cx({ selected: previewState === PreviewState.AWAY })
        }>
        Offline
      </button>
    </div>
  </div>
)

export default PreviewButtons



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/WelcomeMessage/components/PreviewButtons/index.js